<template>
  <div class="expansion-panel overflow-hidden">
    <div
      class="header flex justify-between items-center py-4 px-[29.5px] cursor-pointer uppercase not-italic text-base font-semibold"
      @click="toggleExpansion"
    >
      {{ title }}
      <v-icon :name="isExpanded ? 'chevron-up-solid' : 'chevron-down-solid'" :size="-6" connotation="cta" />
    </div>
    <div v-show="isExpanded" class="content pt-0 px-4 pb-4 bg-[#f2f2f2] overflow-y-auto">
      <slot></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';
import { VIcon } from '@vonage/vivid-vue';

const emit = defineEmits(['update:open']);

const props = defineProps({ title: { type: String, required: false }, open: { type: Boolean, required: true } });
const isExpanded = ref(props.open);
function toggleExpansion() {
  isExpanded.value = !isExpanded.value;
  emit('update:open', isExpanded.value);
}
watch(
  () => props.open,
  () => {
    isExpanded.value = props.open;
  }
);
</script>
<style scoped lang="scss">
.header {
  background-color: var(--vvd-color-canvas);
  color: var(--dp-color-cta-500);
}

.content {
  height: calc(100vh - 7rem);
}
</style>
